import React from "react";
import { TurnrGrid } from "~/components/TurnrGrid.jsx";
import AvatarAndItemName from "~/components/items/AvatarAndItemName.jsx";
import ComplaintStatusChip from "~/components/chips/statusChips/complaintStatusChip/ComplaintStatusChip.jsx";
import { OrderItemStatusChip } from "~/components/chips/statusChips/OrderItemStatusChip.jsx";
import { OrderItemRefundStatusChip } from "~/components/chips/statusChips/OrderItemRefundStatusChip.jsx";
import { ExchangeStatusChip } from "~/components/chips/statusChips/ExchangeStatusChip.jsx";
import EntityActionsDotsMenu from "~/components/entityAction/EntityActionsDotsMenu.jsx";
import { TurnrCard, TurnrCardContent } from "~/components/card/TurnrCard.jsx";
import { CustomerComplaintInfo } from "~/components/Complaint.jsx";
import SpecialItemLine from "./_components/SpecialItemLine";
import { getReturnReasonTranslatedSmart } from "~/cores/returnReasonCore";
import { TurnrFontAwesomeIcon } from "~/components/buttons/icon-buttons/TurnrFontAwesomeIconButton";
import { faCircle } from "@fortawesome/pro-solid-svg-icons";
import { COLORS } from "rylak-common/src/constants";
import { ORDER_ITEM_REFUND_STATUS } from "~/constants";

function ReturnReasonsPart({ returnReasons, appProps }) {
    let lastMainReasonId = null;
    const returnReasonsTextsCombined = returnReasons?.reduce((combinedTexts, returnReasonData) => {
        const { returnReason, returnSubReason, text } = returnReasonData;

        const mainText =
            text ||
            getReturnReasonTranslatedSmart({
                returnReason,
                appProps,
            }) ||
            returnReason.name;
        const secondaryText =
            getReturnReasonTranslatedSmart({
                returnReason: returnSubReason,
                appProps,
            }) ||
            returnSubReason?.name ||
            text;

        if (!returnSubReason) {
            combinedTexts.push(mainText);
        } else if (lastMainReasonId !== returnReason?.id) {
            combinedTexts.push(mainText + ": " + secondaryText);
        } else {
            combinedTexts[combinedTexts?.length - 1] += ", " + secondaryText;
        }
        lastMainReasonId = returnReason?.id;
        return combinedTexts;
    }, []);

    return (
        <div
            style={{
                display: "flex",
                gap: "5px",
                alignItems: "center",
                justifyContent: "flex-end",
                textAlign: "right",
                flexWrap: "wrap",
                maxWidth: "230px",
            }}
        >
            {returnReasonsTextsCombined.map((text, index) => {
                return (
                    <React.Fragment key={index}>
                        <div
                            style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "5px",
                            }}
                        >
                            {returnReasonsTextsCombined?.length > 1 && index !== 0 && <TurnrFontAwesomeIcon width={"3px"} style={{ color: COLORS.WEAK_TEXT }} icon={faCircle} />}
                            <div
                                style={{
                                    display: "flex",
                                    alignItems: "center",

                                    gap: "10px",
                                    color: COLORS.WEAK_TEXT,
                                    fontSize: "9px",
                                }}
                            >
                                <div>{text}</div>
                            </div>
                        </div>
                    </React.Fragment>
                );
            })}
        </div>
    );
}

function filterOrderItemStatus({ orderItem }) {
    const orderItemStatus = orderItem?.orderItemStatus;
    // const returnStatus = getReturnStatus({ orderReturn });
    // if (
    //     returnStatus === RETURN_STATUS.AWAITING_SHIPMENTS &&
    //     orderItemStatus === ORDER_ITEM_STATUS.AWAITING_RETURN
    // ) {
    //     return null;
    // }
    return orderItemStatus;
}

const ORDER_ITEM_REFUND_STATUSES_TO_SKIP = [ORDER_ITEM_REFUND_STATUS.EXCHANGE_NO_REFUND];

function filterRefundStatus({ orderItem }) {
    const status = orderItem?.refundStatus;
    return !ORDER_ITEM_REFUND_STATUSES_TO_SKIP.includes(status) && status;
}

export default function ReturnItemsPart(props) {
    const { returnItemsService, reloadData, appProps, orderReturn } = props;

    return (
        <div style={{ marginBottom: "0.5px" }}>
            <TurnrGrid container spacing={0}>
                {returnItemsService?.data?.map((orderItem, index) => {
                    const orderItemStatus = filterOrderItemStatus({
                        orderItem,
                        orderReturn,
                    });
                    const complaint = orderItem?.customerComplaint;
                    const exchange = orderItem?.exchangeItems?.[0];
                    const complaintStatus = complaint?.orderItemComplaintStatus;
                    const refundStatus = filterRefundStatus({ orderItem });

                    const returnReasons = orderItem?.returnReasons;

                    return (
                        <TurnrGrid item xs={12} key={index}>
                            <TurnrCard style={{ borderRadius: 0 }}>
                                <TurnrCardContent style={{ position: "relative" }}>
                                    {complaint && <SpecialItemLine height={"calc(100% - 50px)"} top={70} />}

                                    <div
                                        style={{
                                            marginLeft: "50px",
                                        }}
                                    >
                                        <TurnrGrid container spacing={1} wrap={"nowrap"} justifyContent={"space-between"}>
                                            <TurnrGrid container item spacing={1} justifyContent={"space-between"}>
                                                <TurnrGrid item>
                                                    <div
                                                        style={{
                                                            marginLeft: "-50px",
                                                        }}
                                                    >
                                                        <AvatarAndItemName
                                                            shopLink={false}
                                                            style={{
                                                                maxWidth: "280px",
                                                            }}
                                                            orderItem={orderItem}
                                                        />
                                                    </div>
                                                </TurnrGrid>

                                                <TurnrGrid
                                                    item
                                                    style={{
                                                        marginLeft: "auto",
                                                    }}
                                                >
                                                    <div
                                                        style={{
                                                            display: "flex",
                                                            flexDirection: "column",
                                                            gap: "10px",
                                                        }}
                                                    >
                                                        <div
                                                            style={{
                                                                marginLeft: "auto",
                                                                display: "flex",
                                                                gridGap: "10px",
                                                                marginTop: "3px",
                                                            }}
                                                        >
                                                            {exchange && (
                                                                <ExchangeStatusChip {...props} exchangeOrder={exchange?.exchangeOrder} exchangeToItem={exchange} showLabel={false} size={"small"} />
                                                            )}
                                                            {orderItemStatus && <OrderItemStatusChip status={orderItemStatus} showLabel={true} size={"small"} toolTipPlacement="top" />}
                                                            {refundStatus && <OrderItemRefundStatusChip toolTipPlacement="top" status={refundStatus} showLabel={true} size={"small"} />}
                                                        </div>
                                                        {returnReasons.length > 0 && (
                                                            <div
                                                                style={{
                                                                    marginLeft: "auto",
                                                                }}
                                                            >
                                                                <ReturnReasonsPart appProps={appProps} returnReasons={returnReasons} />
                                                            </div>
                                                        )}
                                                    </div>
                                                </TurnrGrid>
                                            </TurnrGrid>
                                            <TurnrGrid item>
                                                <EntityActionsDotsMenu appProps={appProps} entity={orderItem} onSuccess={reloadData} />
                                            </TurnrGrid>
                                        </TurnrGrid>
                                    </div>
                                </TurnrCardContent>
                                {complaint && (
                                    <TurnrCardContent
                                        style={{
                                            position: "relative",
                                            paddingTop: "0",
                                        }}
                                    >
                                        <SpecialItemLine width={"15px"} top={19} />
                                        <div
                                            style={{
                                                marginLeft: "47px",
                                                display: "flex",
                                            }}
                                        >
                                            <div
                                                style={{
                                                    marginRight: "10px",
                                                    marginTop: "7px",
                                                }}
                                            >
                                                {complaint && (
                                                    <ComplaintStatusChip
                                                        onSuccess={reloadData}
                                                        appProps={appProps}
                                                        order={orderItem?.order}
                                                        orderReturn={orderItem?.orderReturn}
                                                        status={complaintStatus}
                                                        toolTipPlacement={"top"}
                                                        coloredDotVariant={true}
                                                        showLabel={false}
                                                        size={"small"}
                                                    />
                                                )}
                                            </div>

                                            {complaint && <CustomerComplaintInfo appProps={appProps} customerComplaint={complaint} showImage showComplaintText showResponseText />}
                                        </div>
                                    </TurnrCardContent>
                                )}
                            </TurnrCard>
                        </TurnrGrid>
                    );
                })}
            </TurnrGrid>
        </div>
    );
}
